<template>
    <button class="button" :class="{loading}" @click="$emit('click')">
        <i v-if="loading" class="animate-spin icon-spin4"></i> <slot></slot>
    </button>
</template>

<script>
    export default {
        name: "Button",

        emits: [
            'click'
        ],

        props: {
            loading: {
                type: Boolean,
                default: false,
            },

        },

    }
</script>

<style>
    .button {
        min-width: 60px;
        padding: 10px 20px;
        border: none;
        border-radius: 4px;
        font-size: 16px;
        line-height: 1;
        text-align: center;
        color: #fff;
        background: #2f75cd;
        cursor: pointer;
    }

    .loading {
        padding-left: 10px;
    }

    .button:hover {
        background: #1f66bf;
    }

    .gray {
        color: #333;
        background: #ccc;
    }

    .gray:hover {
        background: #bbb;
    }

    .red {
        color: #fff;
        background: #ad0100;
    }

    .red:hover {
        background: #c60100;
    }
</style>